import React from "react";

/**
 * WhatsApp pages use the same `body-wrapper` offset as the rest of the ERP.
 * Panel and fill variants wrap content in `container-fluid` + `card` so spacing
 * matches Purchase, Sales Target, and other table pages.
 */
export default function WhatsAppPageShell({ children, className = "" }) {
  const shellClass = ["body-wrapper", "whatsapp-page-shell", className]
    .filter(Boolean)
    .join(" ");

  const isFill = className.includes("whatsapp-page-shell--fill");
  const isPanel = className.includes("whatsapp-page-shell--panel");

  if (!isFill && !isPanel) {
    return <div className={shellClass}>{children}</div>;
  }

  return (
    <div className={shellClass}>
      <div
        className={[
          "container-fluid",
          "whatsapp-page-container",
          isFill ? "whatsapp-page-container--fill" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div
          className={[
            "card",
            "w-100",
            "position-relative",
            "overflow-hidden",
            "rounded-3",
            "whatsapp-page-card",
            isFill ? "whatsapp-page-card--fill" : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          <div
            className={[
              "whatsapp-page-card-body",
              isFill ? "whatsapp-page-card-body--fill" : "",
            ]
              .filter(Boolean)
              .join(" ")}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
